import React from "react";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import {
  BulkPlanCreationStore,
  CreationStatus,
} from "../BulkPlanCreationStore";
import { BulkPlanInfo } from "./BulkPlanInfo";
import { BulkPlanFields } from "./BulkPlanFields";

interface PropsBulkPlanContent {
  store: BulkPlanCreationStore;
}

export const BulkPlanContent: React.FC<PropsBulkPlanContent> = observer(
  ({ store }) => {
    const { taskNames, creationStatus } = store;
    const statusContent: Record<CreationStatus, React.ReactNode> = {
      blocked: (
        <BulkPlanInfo
          title={t(
            "The calendar of these instances has already been created and contains tasks",
          )}
          tasks={taskNames}
        />
      ),
      decision: (
        <BulkPlanInfo
          title={t(
            "The calendar plan cannot be created in some instances because it has already been created and contains tasks",
          )}
          tasks={taskNames}
        />
      ),
      canCreate: <BulkPlanFields />,
    };
    return creationStatus && statusContent[creationStatus];
  },
);
